import { useContext, useEffect, useState, useRef } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { useSelector, useDispatch } from "react-redux";
import { useLocation, Link } from 'react-router-dom';

import MenuContext from '../../store/MenuContext';
import { getLabConfig, getCategories,getSuperCategory,getTestInfo,getRequiredTests } from '../../utils/api';
import Test from './Test';
import {CategoriesSuper2} from '../../components/Categories/CategoriesSuper';
import { initTestsThunk, currentTestsThunk, prevTestsThunk, nextTestsThunk, gotoTestsThunk, sortTestsThunk, searchTestsThunk, setIsLoading, getTestsActions } from '../../store/tests';
import TestsClasses from './AvailableTests.module.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AvailableTests = (props) => {
    const testsState = useSelector(state => state.tests);
	
	let superCat='';
	if (testsState.subcat.length > 0) {
		superCat=1;
	}
    const dispatch = useDispatch();
	const location = useLocation();
   
	const [categories, setCategories] = useState([]);
	const [superC,setSuperC] = useState('');

    useEffect(() => {
        async function fetchCategories() {
            const fetchedCategories = await getCategories(1);
			const fetchedSuper = await getSuperCategory(testsState.subcat,fetchedCategories);
			setSuperC(fetchedSuper);
            setCategories(fetchedCategories);
        }

        fetchCategories();
    }, []);

	const [requiredTests,setRequiredTests] = useState([]);
	const [conTests,setConTests] = useState([]);
	useEffect(() => {
		async function fetchRequiredTests() {
			const reqTests = await getRequiredTests();
			const tests = Array.isArray(reqTests)
			  ? reqTests
			  : typeof reqTests === "string"
			  ? [reqTests]
			  : [];
			if(tests.includes("CANNOT ORDER")) {
				setRequiredTests("CANNOT ORDER");
			}else{
				setRequiredTests(reqTests); 
				
				const conTests = await getLabConfig("DTCCONDITIONALTEST");
				const test2Array = typeof conTests === "string"
				  ? conTests.split(",")
				  : Array.isArray(conTests)
				  ? conTests
				  : [];
					// console.log(test2Array);
					// console.log(test2Array.length);
					const conTestInfo = [];
					for (let i=0; i< test2Array.length; i++) {
						conTestInfo[i] = await getTestInfo(test2Array[i]);
					};
					setConTests(conTestInfo);    
			}
		}
		fetchRequiredTests();
	}, []);

	const [HeaderJson, setHeaderJson] = useState([]);
	useEffect(() => {
        async function fetchHeaderJson() {
            const headerJson = await getLabConfig('DTCHOMEJSONLD');
            setHeaderJson(headerJson);
        }
        fetchHeaderJson();
    }, []);


	const [inputValue, setInputValue] = useState('');
	const [searchTerm, setSearchTerm] = useState(() => sessionStorage.getItem("searchTerm") || '');
    const isInitial = useRef(true);

	useEffect(() => {
		if (!isInitial.current && searchTerm && searchTerm.trim() !== '') {
			const searchTimeout = setTimeout(() => {
				dispatch(setIsLoading());
				dispatch(searchTestsThunk(searchTerm.trim(), sessionStorage.getItem("topcatn"), sessionStorage.getItem("topcatd")));
			}, 750);

			return () => {
				clearTimeout(searchTimeout);
			};
		}
		isInitial.current = false;
	}, [searchTerm, dispatch]);

	useEffect(() => {
		let ignore = false;
		const page = location.state?.currentpage ?? 1;

		async function fetchData() {
		  if (!testsState.tests || testsState.tests.length === 0) {
			await dispatch(setIsLoading());

			if (!ignore) {
			  const sessionSearch = sessionStorage.getItem("searchTerm");
			  if (!sessionSearch || sessionSearch.trim() === '') {
				dispatch(getTestsActions().setSearch(''));
			  }

			  if (page === 1) {
				await dispatch(initTestsThunk(
				  sessionStorage.getItem("topcatn"),
				  sessionStorage.getItem("topcatn")
				));
			  } else {
				await dispatch(currentTestsThunk(page));
			  }
			}
		  }
		}

		fetchData();

		return () => {
			ignore = true;
		};
	}, [dispatch, location.state?.currentpage]);;
	useEffect(() => {
		
		const script = document.createElement('script');
		script.type = 'application/ld+json';
		try {
			const headerData = JSON.parse(HeaderJson);
			const schemaData = {
			  "@context": "https://schema.org/",
			  ...headerData,
			};
			const itemListElement = testsState.tests.map(test => ({
			  "@type": "Offer",
			  "itemOffered": {
				"@type": "MedicalTest",
				"name": test.TestName,
				"description": test.DTCTestDescription
			  },
			  "price": test.DTCPrice,
			  "priceCurrency": "USD",
			  "availability": "https://schema.org/InStock"
			}));
			schemaData.offers = {
			  "@type": "OfferCatalog",
			  "name": "Lab Test Catalog",
			  "itemListElement": itemListElement
			};
			script.textContent = JSON.stringify(schemaData);
		} catch (error) {
			console.log("Invalid JSON-LD:", error);
		}
		document.head.appendChild(script);
		return () => {
			// Cleanup to prevent duplication if the component is re-mounted
			document.head.removeChild(script);
		};
	}, [HeaderJson]);

	let page;
	let ignore=false;
	if (location.state) {
		page=location.state.currentpage;
	}else{
		page=1;
	};
	if (Number(props.page)) {
		page=props.page;
	}
    let nexturl = `../availableTestwithCat/` + (Number(page)+1);
	if (testsState.totalTests === 0 || Number(page) === Math.ceil(testsState.totalTests / testsState.testsPerPage)) {
	  nexturl = `#`; // stop the link if on last page
	}
    let prevurl = `../availableTestwithCat/` + (Number(page)-1);
	if (testsState.totalTests === 0 || Number(page) === 1) {
	  prevurl = `#`; // stop the link if on last page
	}
		
    const handlePagingCurrent = () => {
        dispatch(setIsLoading());
        dispatch(currentTestsThunk(page));
    };	
    const handlePagingNewPage = (newpage) => {
        dispatch(setIsLoading());
        dispatch(gotoTestsThunk(newpage));
    };	
    const handlePagingPrev = () => {
        dispatch(setIsLoading());
        dispatch(prevTestsThunk());
    };

    const handlePagingNext = () => {
        dispatch(setIsLoading());
        dispatch(nextTestsThunk());
    };
	
	const clearSearch = () => {
		setSearchTerm('');
		setInputValue('');
		sessionStorage.removeItem("searchTerm");
		dispatch(setIsLoading());
		dispatch(getTestsActions().setSearch(''));
		dispatch(initTestsThunk(
		  sessionStorage.getItem("topcatn"),
		  sessionStorage.getItem("topcatn")
		));
	  }
	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'instant' });
	}, [testsState]);

	const handleInputChange = (e) => {
		setInputValue(e.target.value);
	};

	const handleKeyDown = (e) => {
		if (e.key === 'Enter' && inputValue.trim() !== '') {
			setSearchTerm(inputValue.trim());                    
			sessionStorage.setItem("searchTerm", inputValue.trim());  
                   
		}
	};
    const handleSort = (event) => {
        dispatch(setIsLoading());
        dispatch(sortTestsThunk(event.target.value));
    };
	const [sortOrder,setSortOrder] = useState("PRICELH");
	const handleSort2 = () => {
	  dispatch(setIsLoading());

	  const newSortOrder = sortOrder === "PRICEHL" ? "PRICELH" : "PRICEHL";
	  dispatch(sortTestsThunk(newSortOrder));
	  setSortOrder(newSortOrder);
	};

    const menuTheme = useContext(MenuContext);
	
    const errorDisplay = <p className={`${TestsClasses.status} ${TestsClasses.error}`}>Oops, an error has occurred.</p>;
    
	if (page !== testsState.page) {
		handlePagingNewPage(page);
	};

   return <div className={TestsClasses.contentArea}>
        <section className={TestsClasses.sortInfo}>
			{menuTheme !== "HAMBURGER" &&
				<div>
					<span className={TestsClasses.testsLength}>Tests available: {testsState.totalTests}</span>
					<select aria-label="Sort method" className={TestsClasses.sort} value={testsState.sort} onChange={handleSort}>
						<option value='ALPHAUP'>A to Z</option>
						<option value='ALPHADOWN'>Z to A</option>
						<option value='PRICELH'>Price low to high</option>
						<option value='PRICEHL'>Price high to low</option>
					</select>
				</div>
			}
        </section>

        {testsState.isLoading && <p className={`${TestsClasses.status} ${TestsClasses.loading}`}>Loading...</p>}
		{menuTheme === "HAMBURGER" &&
		<>
		  <div>
			<div className={TestsClasses.pageimage}>
			 <div className={TestsClasses.cattext}>
				<div className={TestsClasses.h1cat}>{testsState.categoryname}</div>
				<div className={TestsClasses.h2cat}>{testsState.categorydesc}</div>	
				<div className={TestsClasses.searchContainer}>
					<label htmlFor='testSearch' className={TestsClasses.searchLabel}>
						<span className="sr-only">Search tests by name</span>
						<i className={TestsClasses.searchIcon}><FontAwesomeIcon icon={faMagnifyingGlass}/></i>
						<input type='search' id='testSearch' name='testSearch' className={TestsClasses.headerSearch} placeholder='Search Test Name' value={inputValue} 	onChange={handleInputChange}
		onKeyDown={handleKeyDown}/>
						 {searchTerm && (
							<button type="button" onClick={clearSearch} className={TestsClasses.clearButton} aria-label="Clear search">
							  ×
							</button>
						  )}
					</label>
				{searchTerm && (
					<div style={{ marginTop: '0.5rem' }}>
						<button type="button" onClick={clearSearch} className={TestsClasses.clearInLineButton} aria-label="Clear search" >
							Clear Search
						</button>
					</div>)}
				</div>
			  </div>
			</div>
		</div>
		<section>
			<button onClick={handleSort2} className={TestsClasses.testsHeader2}>
			  <div className={TestsClasses.iconTextWrapper}>
				<img src={`/images/Icons/Up Down.png`} alt="Sort Icon" />
				{sortOrder === "PRICEHL" && <span>Price (Low-High)</span>}
				{sortOrder === "PRICELH" && <span>Price (High-Low)</span>}
			  </div>
			</button>

		</section>
		</>
        }
		<section className={TestsClasses.dtctests}>
            {!(testsState.hasError || testsState.isLoading) && testsState.tests.map((test) => <Test key={test.ID} test={test} page={testsState.page} conTests={conTests} requiredTests={requiredTests}/>)}
        </section>

        <section className={TestsClasses.paging}>
            <div className={TestsClasses.pagingWrapper}>
			{Math.ceil(testsState.totalTests / testsState.testsPerPage) !== 1 &&
			<>
				<Link
					to={prevurl}
                    className={TestsClasses.linkButton}
				>
                    <FontAwesomeIcon icon={faAngleLeft} className={TestsClasses.pagingIcon}/>
					<span className="sr-only">Previous Page</span>					
                </Link>
                <span className={TestsClasses.pagingText}>Page {testsState.page} of {Math.ceil(testsState.totalTests / testsState.testsPerPage)}</span>

				<Link
                    to={nexturl}
                    className={TestsClasses.linkButton}
                >
                    <FontAwesomeIcon icon={faAngleRight} className={TestsClasses.pagingIcon}/>
					<span className="sr-only">Next Page</span>					
                </Link>
				</>
			}
            </div>
        </section>
		{superCat &&
			<section className={TestsClasses.dtctests2}>
				<CategoriesSuper2 SubCat={testsState.subcat} CurrentCat={testsState.categoryname} SuperCat={superC} />
			</section>
		}
        <ToastContainer position="top-center" autoClose={1000} hideProgressBar={true} newestOnTop={false} closeOnClick rtl={false} draggable theme="light" toastStyle={{ backgroundColor: "#eeeeee", color: "#044B93" }} />
	     
  	    
    </div>;
};

export default AvailableTests;